module.exports = __webpack_public_path__ + "img/icon-10.b4ed3941.png";